<aside class="h-full" aria-label="Sidebar">
  <div
    class="h-full overflow-y-auto py-4 px-3 bg-white shadow-lg border rounded-xl"
  >
    <ul class="space-y-2">
      <li *ngFor="let menu of searchMenu">
        <a
          class="flex justify-between cursor-pointer items-center px-2 py-4 text-base text-gray-900 rounded-lg"
          [routerLink]="menu.route"
          (click)="redirect(menu.route)"
          [ngClass]="[
            isActive(menu.route)
              ? 'bg-primary-500 text-white'
              : 'hover:bg-gray-100'
          ]"
        >
          <span
            [ngClass]="[isActive(menu.route) ? 'text-white' : '']"
            class="ml-3"
          >
            {{ menu.label }}</span
          >
          <pulse-icon *ngIf="false" icon="check"></pulse-icon>
        </a>
      </li>
    </ul>
  </div>
</aside>
